
import { computed, defineComponent, ref } from 'vue'
import { addTodo, stateTodo } from '@/store/todoStore'
import Todo from '@/components/Todo.vue'

document.title = 'Tarefinhas'

export default defineComponent({
  name: 'Home',
  components: {
    Todo
  },
  setup () {
    const newTaskText = ref('')
    const todos = computed(() => {
      return stateTodo.todoList
    })
    // ❌: Não enviar vazio
    function addNewTodo () {
      addTodo({
        text: newTaskText.value,
        completed: false
      })

      newTaskText.value = ''
    }

    function randomPlaceholder (): string {
      const placeholders: Array<string> = [
        'Levar lixo para fora',
        'Dormir cedo',
        'Sentir a brisa',
        'Deitar em uma rede'
      ]

      const placeholderIndexSelected = Math.floor(
        Math.random() * placeholders.length
      )

      return `${placeholders[placeholderIndexSelected]}...`
    }

    return {
      addNewTodo,
      todos,
      newTaskText,
      randomPlaceholder
    }
  }
})
